export var SystemProcedure;
(function (SystemProcedure) {
    SystemProcedure["CreditorEndedCase"] = "CREDITOR_ENDED_CASE";
    SystemProcedure["EndCase"] = "END_CASE";
    SystemProcedure["Overpayment"] = "OVERPAYMENT";
    SystemProcedure["RemainderReminder"] = "REMAINDER_REMINDER";
    SystemProcedure["EndCaseAccord"] = "END_CASE_ACCORD";
    SystemProcedure["PrincipalPayment"] = "PRINCIPAL_PAYMENT";
    SystemProcedure["PaymentOnCourtCase"] = "PAYMENT_ON_COURT_CASE";
    SystemProcedure["Update"] = "UPDATE";
    SystemProcedure["InteractionSentToDebtor"] = "INTERACTION_SENT_TO_DEBTOR";
    SystemProcedure["PaymentPlanInitial"] = "PAYMENT_PLAN_INITIAL";
    SystemProcedure["PaymentPlanDocumentSigned"] = "PAYMENT_PLAN_DOCUMENT_SIGNED";
    SystemProcedure["PaymentPlanReminder"] = "PAYMENT_PLAN_REMINDER";
    SystemProcedure["PaymentPlanPayment"] = "PAYMENT_PLAN_PAYMENT";
    SystemProcedure["PaymentPlanAutoPaymentFailure"] = "PAYMENT_PLAN_AUTO_PAYMENT_FAILURE";
    SystemProcedure["PaymentPlanBSLSSubmitFailed"] = "PAYMENT_PLAN_BS_LS_SUBMIT_FAILED";
    SystemProcedure["PaymentPlanBSLSRejected"] = "PAYMENT_PLAN_BS_LS_REJECTED";
    SystemProcedure["PaymentPlanBSLSAgreementCancelled"] = "PAYMENT_PLAN_BS_LS_AGREEMENT_CANCELLED";
    SystemProcedure["PaymentPlanDeadline"] = "PAYMENT_PLAN_DEADLINE";
    SystemProcedure["PaymentPlanCanceled"] = "PAYMENT_PLAN_CANCELED";
    SystemProcedure["PaymentPlanTwoHourActivationReminder"] = "PAYMENT_PLAN_TWO_HOUR_ACTIVATION_REMINDER";
    SystemProcedure["PaymentPlanOneDayActivationReminder"] = "PAYMENT_PLAN_ONE_DAY_ACTIVATION_REMINDER";
    SystemProcedure["PaymentPlanThreeDayActivationReminder"] = "PAYMENT_PLAN_THREE_DAY_ACTIVATION_REMINDER";
    SystemProcedure["CancelUnactivatedPaymentPlansAfterActivationDeadline"] = "CANCEL_UNACTIVATED_PAYMENT_PLANS_AFTER_ACTIVATION_DEADLINE";
    SystemProcedure["PaymentPlanCreationByCaseworker"] = "PAYMENT_PLAN_CREATION_BY_CASEWORKER";
    SystemProcedure["BankAccountDetailsApprovalRefund"] = "BANK_ACCOUNT_DETAILS_APPROVAL_REFUND";
    SystemProcedure["DebtExpired"] = "DEBT_EXPIRED";
    SystemProcedure["DebtExpiresWithinThreeMonths"] = "DEBT_EXPIRES_WITHIN_THREE_MONTHS";
    SystemProcedure["DebtExpiresWithinThreeMonthsWithFoundation"] = "DEBT_EXPIRES_WITHIN_THREE_MONTHS_WITH_FOUNDATION";
    SystemProcedure["DebtorCanBeRegisteredInDebtRegister"] = "DEBTOR_CAN_BE_REGISTERED_IN_DEBT_REGISTER";
    SystemProcedure["DebtorIsUnderage"] = "DEBTOR_IS_UNDERAGE";
    SystemProcedure["Address"] = "ADDRESS";
    SystemProcedure["Active"] = "ACTIVE";
    SystemProcedure["Dead"] = "DEAD";
    SystemProcedure["Disappeared"] = "DISAPPEARED";
    SystemProcedure["MovedAbroad"] = "MOVED_ABROAD";
    SystemProcedure["Homeless"] = "HOMELESS";
    SystemProcedure["CompanyActive"] = "COMPANY_ACTIVE";
    SystemProcedure["Inactive"] = "INACTIVE";
    SystemProcedure["OperationsCeased"] = "OPERATIONS_CEASED";
    SystemProcedure["AddressProtection"] = "ADDRESS_PROTECTION";
    SystemProcedure["NewRKIRegristration"] = "NEW_RKI_REGISTRATION";
    SystemProcedure["DeletedRKIRegistration"] = "DELETED_RKI_REGISTRATION";
    SystemProcedure["DeletedRKIRegistrationWillingnessToPay"] = "DELETED_RKI_REGISTRATION_WILLINGNESS_TO_PAY";
    SystemProcedure["GuardianStatus"] = "GUARDIAN_STATUS";
    SystemProcedure["DissolutionStatus"] = "DISSOLUTION_STATUS";
    SystemProcedure["BOBEHANDLING"] = "BOBEHANDLING";
    SystemProcedure["AKSFailed"] = "AKS_FAILED";
})(SystemProcedure || (SystemProcedure = {}));
export const SystemProcedureId = {
    CreditorEndedCase: 'c8f46b94-3a17-4345-ae72-8d2fcb2ed2f9',
    Overpayment: '2bf2187e-259e-4176-a762-859e4688ba3b',
    EndCase: '77b8678a-a6dd-4005-b320-7a9cc963f751',
    EndCaseAccord: 'daeb7db3-8f2e-48bd-b075-cdcf0faa6435',
    PrincipalPayment: '61ddc972-b02d-44e0-b9bc-3c746e1c1be4',
    RemainderReminder: '61ddc972-b02d-44e0-b9bc-3c746e1c1be4',
    PaymentOnCourtCase: '47d383b7-f239-4566-abb2-58cae4d9bd30',
    Update: 'e205691e-4197-4152-81a6-09de315cb70a',
    PaymentPlanInitial: '0094d8b6-e037-43ed-a559-6c813f1ae4e8',
    PaymentPlanReminder: 'fd8def41-235c-45fc-a4e4-37e435672034',
    PaymentPlanPayment: 'ae304800-fc5c-4e27-9982-8165ce338735',
    PaymentPlanAutoPaymentFailure: 'e79ed266-6cc8-46d6-9547-98207e34c9fe',
    PaymentPlanBSLSSubmitFailed: '767024fe-a406-4c8a-92fd-bbb39bd9a97f',
    PaymentPlanBSLSRejected: '2afe722c-f8dd-4852-b73d-47f7fbdfb929',
    PaymentPlanBSLSAgreementCancelled: '98371161-f815-469f-936a-b8cfcc2c0f7e',
    PaymentPlanDeadline: '23df7219-0e65-4988-8214-96c7c51b0fd4',
    PaymentPlanCanceled: '48bb8a74-f4d3-429f-9e92-6a7af3b9bae0',
    PaymentPlanTwoHourActivationReminder: '7bfad0f0-a988-4158-916e-05c04a5355b9',
    PaymentPlanOneDayActivationReminder: '04431f4c-6edd-4b71-a74e-3185bf85e1d0',
    PaymentPlanThreeDayActivationReminder: '3e121ddc-178c-4ed8-9d06-4932d675d3da',
    PaymentPlanCreationByCaseworker: '9a845e01-0cb7-4a5c-aff6-8049bbf2be80',
    DebtExpired: 'dca63891-d881-4b78-9f28-ec7695dadc16',
    DebtExpiresWithinThreeMonths: '0dd28b1a-1bcf-4e51-90f9-7bfcd8ea3078',
    DebtExpiresWithinThreeMonthsWithFoundation: '12dcdfd5-b950-40e3-82d9-edc7ffddf1dc',
    DebtorCanBeRegisteredInDebtRegister: 'd402cb4e-8632-4238-aad7-bc480641bd99',
    DebtorIsUnderage: '3fbba86c-fc97-4584-95c1-f3b20f9f883e',
    Address: 'b9c1d0f7-ad7f-42ec-8f92-25053160b7f0',
    Active: '577b3e2b-d0ae-448f-9247-f4c60e23f67a',
    Dead: 'da88e103-c41a-4a9e-9b85-9e2a8154b638',
    Disappeared: '0e703bd6-347b-41bb-a7d7-5d49b3ddc30a',
    MovedAbroad: 'd255fc58-6e33-4314-90b0-7badccde265c',
    Homeless: 'ab502d87-9aa0-4a92-8b62-1265eea7b183',
    CompanyActive: '002e7adf-602b-45af-abdd-cd0385068be0',
    Inactive: 'ba2e6b27-7362-4a20-8b8f-a95009aff594',
    OperationsCeased: '1c1c7c9a-645d-4774-aa36-799046a4e3e6',
    AddressProtection: 'a32bc204-a5a3-4682-97db-1fe9ef474878',
    NewRKIRegristration: '771c9e5b-dd24-45be-a715-276f9549d381',
    DeletedRKIRegistration: '8ab48245-f8fa-4c2c-a0f5-2ce3549b37fe',
    DeletedRKIRegistrationWillingnessToPay: 'd1d9540c-65de-431a-a565-b0479b4be465',
    GuardianStatus: 'a3589d46-f414-4219-812d-9ffeef3fe612',
    DissolutionStatus: 'e9a22007-4ddd-4e06-8208-4a95c60d683e',
    BOBEHANDLING: '92a4abaf-89d1-4a08-90dc-07e2d9ca62d8',
    AKSFailed: 'cd34cce6-e11a-4b6f-a4f0-12a6c496d14a',
};
//# sourceMappingURL=index.js.map